export const LOGIN_URL = '/auth/login/'
export const LOGOUT_URL = '/auth/logout/'
export const SEND_CODE_URL = '/auth/send_confirm_code'
export const COMPARE_CODE_URL = '/auth/compare_confirm_code'
export const REGISTRATION_URL = '/auth/registration/'
export const AUTHENTICATE_FACEBOOK_URL = '/auth/facebook/'
export const USER_INFO = '/users/me/'
export const USER_ROLES_URL = '/users/roles/'
export const USER_UPDATE_URL = '/users/update/'
export const TALENT_LIST_URL = '/talents/'
export const TALENT_CATEGORY_LIST_URL = '/talents/categories/'
export const TALENT_QUALIFICATION_LIST_URL = '/users/qualification/'
export const JOB_LIST_URL = '/jobs/'
export const JOB_CATEGORY_LIST_URL = '/jobs/categories/'
export const SEND_RESET_PASSWORD = '/auth/password/reset/'
export const SEND_CONFIRM_RESET_PASSWORD = '/auth/password/reset/confirm/'
export const AUTHENTICATE_GOOGLE_URL = '/auth/google/'
export const LIST_CATEGORY = '/jobs/categories/'
export const LIST_COUNTRY = '/categories_common/country/list/'
export const LIST_CITY = '/categories_common/city_town/list/'
export const LIST_NEIGHBORHOOD =
  '/categories_common/{cityTownId}/neighborhood/list/'
export const CREATE_JOB = '/jobs/'
export const LIST_TALENT_DETAIL = '/talents/list/{talentId}/'
export const LIST_JOB_DETAIL = '/jobs/{jobId}/'
export const LIST_LEVEL_EXPERIENCE = '/categories_common/level_experience/list/'
export const JOB_ALERT_SETTINGS = '/jobs/alert_setting/'
export const TALENT_ALERT_SETTINGS = '/employers/alert_setting/'
export const LIST_TALENT_ALERT = '/employers/alert_setting/search/'
export const LIST_JOB_ALERT = '/jobs/alert_setting/search/'

export const DETAIL_TALENT = '/talents/{id}/'
export const LIST_CONNECTION_COMMENT = '/talents/{id}/employers/comment/'
export const LIST_EDUCATION_TRAINING = '/talents/{id}/educations/'
export const LIST_WORKING_HISTORY = '/talents/{id}/working/histories/'
export const LIST_EMPLOYMENT_HISTORY = '/talents/{id}/working/histories/'
export const LIST_NOTICE_BOARD = '/talents/{id}/notice_board/'
export const LIST_PROUD_OF = '/talents/{id}/proud/'
export const LIST_WORKING_PORTFOLIO = '/talents/{id}/portfolios/'
export const UPDATE_PROFILE_TALENT = '/talents/{id}/'

export const DETAIL_EMPLOYER = '/employers/{id}/'
export const LIST_CONNECTION_COMMENT_EMPLOYER =
  '/employers/list/{id}/connection_comment/'
export const LIST_EDUCATION_TRAINING_EMPLOYER = '/employers/{id}/educations/'
export const LIST_HISTORY_EMPLOYER = '/employers/list/{id}/history/'
export const LIST_EMPLOYMENT_HISTORY_EMPLOYER = '/employers/{id}/products/'
export const LIST_NOTICE_BOARD_EMPLOYER = '/employers/list/{id}/notice_board/'
export const LIST_PROUD_OF_EMPLOYER = '/employers/{id}/proud/'
export const LIST_WORKING_PORTFOLIO_EMPLOYER = '/employers/{id}/portfolios/'
export const LIST_EMPLOYER = '/employers/'
export const CREATE_PROFILE_EMPLOYER = '/employers/'
export const UPDATE_PROFILE_EMPLOYER = '/employers/{id}/'
export const DELETE_PROFILE_EMPLOYER = '/employers/{id}/'

export const UPDATE_PROUD_OF_EMPLOYER = '/employers/{id}/proud/'
export const UPDATE_PROUD_OF_TALENT = '/talents/{id}/proud/'
export const LIST_HISTORY_EMPLOYER_ADDED = '/employers/{id}/products/'
export const UPDATE_HISTORY_EMPLOYER = '/employers/{id}/products/'
export const LIST_HISTORY_TALENT_ADDED = '/talents/{id}/jobs/histories/'
export const UPDATE_HISTORY_TALENT = '/employers/{id}/products/'
export const UPDATE_WORKING_PORTFOLIO_EMPLOYER = '/employers/{id}/portfolios/'
export const UPDATE_WORKING_PORTFOLIO_TALENT = '/talents/{id}/portfolios/'
export const UPDATE_EDUCATION_TRAINING_EMPLOYER = '/employers/{id}/educations/'
export const UPDATE_EDUCATION_TRAINING_TALENT = '/talents/{id}/educations/'

export const JOB_DETAIL = '/jobs/{id}/'
export const JOB_DETAIL_TALENT = '/jobs/{id}/talent/{talent_id}'
export const JOB_INTEREST = '/jobs/interests/'
export const CHAT_ROOM = '/chat/chat-room/'
export const TALENT_CANCEL_INTEREST_JOB =
  '/jobs/interests/{job_interest_id}/offers/reject/'
export const JOB_INTEREST_DETAIL = '/jobs/interests/{id}/'
export const JOB_REJECT_OFFER = '/jobs/interests/{id}/talent_reject_offer/'
export const LIST_JOB_PENDING = '/jobs/jobs_interest/talent_pending_job/list/'
export const LIST_CURRENT_OFFER_JOBS =
  'jobs/jobs_interest/talent_current_offer_job/list/'
export const JOB_INTEREST_TALENT_ACCEPT_OFFER =
  '/jobs/interests/{id}/offers/accept'

export const CHANGE_PASSWORD = '/auth/password/change/'
export const LIST_SECURITY_QUESTIONS = '/users/security-questions/'
export const CURRENT_SECURITY_QUESTION = '/users/security-questions/me/'
export const UPDATE_CURRENT_SECURITY_QUESTION = '/users/security-questions/me/{user_id}/'
export const NOTIFICATION_SETTINGS = '/users/settings/{user_id}/'

export const LIST_MY_JOBS_ONGOING_EMPLOYER = '/employers/{id}/jobs/ongoing/'
export const LIST_MY_JOBS_APPROVED_EMPLOYER = '/employers/{id}/jobs/approved/'
export const LIST_MY_JOBS_PENDING_EMPLOYER = '/employers/{id}/jobs/pending/'
export const LIST_MY_JOBS_COMPLETED_EMPLOYER = '/employers/{id}/jobs/completed/'
export const SEARCH_MY_JOBS_EMPLOYER = '/employers/{id}/jobs/search/'
export const DELETE_JOB_EMPLOYER = '/employers/{employer_pk}/jobs/{id}/'
export const EDIT_JOB_EMPLOYER = '/employers/{employer_pk}/jobs/{id}/'
export const LIST_INTERESTED_TALENTS = '/jobs/{job_id}/interests/'
export const LIST_JOINED_TALENTS = '/jobs/completed/{job_id}/talents/'
export const LIST_WAIT_FOR_CONFIRMATION_EMPLOYER =
  '/jobs/{job_id}/employers/waiting_confirmation/'
export const LIST_OTHER_TOP_RATED_TALENT_EMPLOYER =
  '/jobs/{job_id}/top_other_talents/'
export const EMPLOYER_MAKE_OFFER = '/jobs/{job_id}/employers/offers/'
export const EMPLOYER_CANCEL_OFFER = '/jobs/{job_id}/employers/cancel/offers/'
export const LIST_MY_JOBS_ONGOING_TALENT = '/talents/{id}/jobs/ongoing/'
export const LIST_MY_JOBS_SUBMITTED_TALENT = '/talents/{id}/jobs/submitted/'
export const LIST_MY_JOBS_CURRENT_OFFER_TALENT = '/talents/{id}/jobs/current/'
export const LIST_MY_JOBS_PENDING_RESPONSE_TALENT =
  '/talents/{id}/jobs/pending/'
export const LIST_MY_JOBS_COMPLETED_TALENT = '/talents/{id}/jobs/completed/'
export const LOVE_TALENT_EMPLOYER = '/employers/{employer_pk}/love/{talent_pk}/'
export const LOVE_TALENT_TALENT = '/talents/love/{talent_id}/'
export const SAVE_TALENT_EMPLOYER = '/employers/{employer_pk}/save/{talent_pk}/'
export const EMPLOYER_APPROVE_JOB_SUBMITTED =
  '/jobs/submitted/{submitted_job_id}/approval/'
export const EMPLOYER_DECLINE_JOB_SUBMITTED =
  '/jobs/submitted/{submitted_job_id}/decline/'
export const LIST_JOBS_TO_MAKE_OFFER = '/employers/job/{talent_id}/can_offer/'
export const SUBMIT_JOB_TALENT = '/talents/{talent_id}/jobs/{job_id}/submit'
export const CANCEL_JOB_TALENT = '/talents/{talent_id}/jobs/{job_id}/cancel'
export const RATING_JOB_TALENT = '/talents/rating/job/'
export const GET_SUBMITTED_JOB_EMPLOYER =
  '/jobs/submitted/{submitted_job_id}/approval/'

export const SEND_CONTACT_US = '/users/contact/'
export const LIST_NEW_NOTIFICAITON = '/notifications/'
export const UNREGISTER_FCM_DEVICE =
  '/notifications/fcm/devices/{registration_id}'
export const REGISTER_FCM_DEVICE = '/notifications/fcm/devices/'
export const NUMBER_NOTIFICAITON = '/notifications/badge/'
export const MARK_READ_NOTIFICAITON = '/notifications/read/'

// list bank , momo
export const GET_LIST_BANK = '/payment/banks/'
export const GET_LIST_MOMO = '/payment/banks/?is_momo=true'

// bank account
export const REQUEST_BANK_ACCOUNT = '/payment/bank-accounts/'

export const ADD_TOPUP = '/payment/topup/'
export const VERIFY_TOPUP = '/payment/topup/verify/'
export const PAYMENT_TRANSFER = '/payment/transfer/'
export const GET_LIST_TRANSACTION = '/payment/transactions/'
export const GET_AVAILABLE_BALANCE = '/users/wallet/{id}/'
export const CHECK_EMAIL_OR_PHONE_EXISTS = '/users/exists/'
export const SYNC_DATA_FROM_USER_PROFILE = '/users/sync/'
export const SIGNUP_INVITE_CODE = '/users/signup-code/{invite_code}/'

// Visa Cards List
export const REQUEST_VISA_CARD = '/payment/visa-cards/'
export const VERIFY_CARD_TOPUP = '/payment/validate-charge/'
// chat token
export const CHAT_TOKEN = '/chat/chat-token/'
// chat save
export const MSG_SAVE = '/chat/chat-save/'
export const DOWNLOAD_INVOICE = '/employers/invoice/'
export const DOWNLOAD_CONTRACT = '/employers/contract/{id}/{talent_id}/'
export const ACCEPT_CONTRACT = '/employers/contractsign/'
export const START_CALL = 'zoom/create-meeting/'
export const JOIN_CALL = 'zoom/join-meeting/'
export const ONLINE_OFFLINE_STATUS = '/chat/online-status/'
export const GET_JOBPICKED_LIST = '/employers/{id}/jobs/job-picked-list/'
// download contract
